<template>
	<div class="wrap">
		<div class="marginl10 padding-10" style="margin: 0 auto;width: 1280px;padding-top: 30px;cursor: pointer;" @click="$router.go(-1)">
			<img src="../../../static/images/back.png" alt="" class="zh-back">
			<span class="back-page">返回上一页</span>
		</div>
		<p class="tit">案件附件列表</p>
		<el-form ref="form" v-model="form"  label-width="80px" style="padding-top: 50px;margin: 0 auto;width:80%">
			  <el-form-item label="文件类型" >
				<el-select v-model="form.type" placeholder="请选择文件类型">
				    <el-option label="图片" value="1"></el-option>
				    <el-option label="zip" value="2"></el-option>
						<el-option label="pdf" value="3"></el-option>
				</el-select>
			  </el-form-item>
			  <el-form-item label="上传者" >
				<el-select v-model="form.user" placeholder="请选择上传者">
				    <el-option v-for="item in authorArr" :label="item" :value="item" :key="item"></el-option>
				</el-select>
			  </el-form-item>
			  <el-form-item>
			     <el-button @click="updialog=true" type="primary">上传附件</el-button>
			  </el-form-item>
		</el-form>
		<template>
		  <el-table  :data="tableData" border style="width: 80%;margin: 0 auto;">
			<el-table-column  prop="jiedian" label="救援节点" width="220" align="center">
				<template slot-scope="scope">
					{{setPoint(scope.row.ucnt.type)}}
				</template>
			</el-table-column>
			<el-table-column  prop="author.name"  label="上传者"  width="220" align="center">
			</el-table-column>
			<el-table-column label="附件内容" align="center">
           <template slot-scope="scope">
              <span v-if="scope.row.ucnt.objType == 100">简报</span>
              <span v-else-if="scope.row.ucnt.objType == 4">一般附件上传</span>
              <span v-else-if="scope.row.ucnt.objType == 15">跟地接社工作人员照片上传</span>
              <span v-else-if="scope.row.ucnt.objType == 16">患者家属照片</span>
              <span v-else-if="scope.row.ucnt.objType == 17">所在医疗机构及科室的照片</span>
              <span v-else-if="scope.row.ucnt.objType == 18">医疗证明及其他相关材料照片</span>
              <span v-else-if="scope.row.ucnt.objType == 19">所去的殡仪及其它政府机构的照片</span>
              <span v-else-if="scope.row.ucnt.objType == 20">死亡证明相关材料照片</span>
              <span v-else>一般附件上传</span>
              <span>-</span>
				    	{{scope.row.ucnt.description}}
			  	</template>
			</el-table-column>
			<el-table-column  prop="date"  label="上传时间" align="center">
				<template slot-scope="scope">
					{{setTime(scope.row.ucnt.createAt)}}
				</template>
			</el-table-column>
			<el-table-column  label="操作" align="center">
				<template slot-scope="scope">
					<a :href='scope.row.ucnt.url'  :download="scope.row.ucnt.description">预览</a>
					<!-- <a :href='scope.row.ucnt.url'  :download="scope.row.ucnt.description">下载</a> -->
				</template>
			</el-table-column>
		  </el-table>
		</template>
		<el-dialog title="附件查看" :visible.sync="centerDialogVisible3" center>
			<el-carousel :interval="4000" type="card" height="200px">
				<el-carousel-item v-for="(item,index) in fileArrurl" :key="index" v-if="item.status == 1">
				  <img style="width: 100%;" :src="item.url">
				</el-carousel-item>
			</el-carousel>
		</el-dialog>
		<el-dialog title="上传附件" :visible.sync="updialog" center>
			<el-form  v-show="updialog" label-width="80px" style="">
				<el-form-item style="width: 80%;margin: 0 auto 20px;" label="附件内容:">
					 <el-input type="textarea" v-model="desc"></el-input>
				</el-form-item>
        <el-form-item style="width: 80%;margin: 0 auto 20px;" label="类型" >
          <el-select v-model="form.status" placeholder="请选择上类型">
              <el-option v-for="item in statusArr" :label="item.name" :value="item.static" :key="item.static"></el-option>
          </el-select>
        </el-form-item>
		  	<el-form-item>
          <!-- :on-remove="handleRemove" -->
		  	<el-upload class="upload-demo"
        accept=".png, .zip, .jpg, .pdf"
        ref="upload"
		  	:on-preview="handlePreview"
		    :on-remove="handleRemove"
		  	:before-remove="beforeRemove"
		   	multiple
		  	:limit="10"
		  	:on-exceed="handleExceed"
		  	:file-list="fileList"
		  	:before-upload="beforeAvatarUpload"
		  	:http-request="requestFile"
		  	 >
		  		<el-button size="small" type="primary":loading="uploadBtn">点击添加</el-button>
		  		<div slot="tip" class="el-upload__tip">可上传10个附件，每个附件大小不得超过8M</div>
		  	</el-upload>
				<el-button size="small" type="primary" @click="uploadFile()">上传</el-button>
		  </el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import axios from 'axios'
	import getObj from "@/util/constants.js"
	import { getAnjianList,uploadFile } from "@/views/axios/api.js"
  import consultingVue from './monitoringCase/consulting.vue'
	 export default {
    data() {
      return {
        form: {
         type:'',
				 user:'',
         status:'',
        },
        fileInd:'',
		    tableData:[],
		    caseid:'',
				authorArr:[],
				centerDialogVisible3:false,
				fileList: [],
				fileUrl:[],
				uploadBtn:false,
				fileArrurl:[],
				updialog:false,
				desc:'',
				caseState:'',
        statusArr:[]
      }
    },
    methods: {
      handleFileChange(file, fileList) {
      // 调用验证方法
      if (!this.validateFile(file)) {
        this.fileList = []
        this.$message.error('文件验证失败，请上传正确的文件格式');
        return;
      }
 
      // 验证通过，手动触发上传
      this.$refs.upload.submit();
    },
    validateFile(file) {
      // 这里可以写验证逻辑，例如检查文件扩展名或者文件类型
      console.log(file)
      const allowedTypes = ['image/jpeg', 'image/png','application/pdf','application/zip'];
      for(var i = 0; i<allowedTypes.length; i++) {
        if(allowedTypes[i] == file.raw.type) {
          return true
        }else {
          return false
        }
      }
    },
      onSubmit() {
        console.log('submit!');
      },
			getTimeStr(){

			},
			getData(){
				var data={
					caseId:this.caseid,
					token:JSON.parse(window.localStorage.getItem("data")).data,
				}
				getAnjianList(data)
				.then( res =>{
					this.tableData=res.data.obj;
					this.getAuthors()
				})
				.catch( err =>{
					console.log(err)
				})
        if(this.$route.query.type == 800) {
          this.statusArr = [
          {static:4,name:'一般附件上传'},
         
        ]
        }else {
          this.statusArr = [
          {static:4,name:'一般附件上传'},
          {static:15,name:'跟地接社工作人员照片上传'},
          {static:16,name:'患者家属照片'},
          {static:17,name:'所在医疗机构及科室的照片'},
          {static:18,name:'医疗证明及其他相关材料照片'},
          {static:19,name:'所去的殡仪及其它政府机构的照片'},
          {static:20,name:'死亡证明相关材料照片'},
        ]
        }
        
			},
			setPoint(num){
				return getObj.pt2txt(num).node
			},
			setTime(str){
				return getObj.time(str)
			},
			getAuthors(){
				for(var i=0;i<this.tableData.length;i++){
					  let str = this.tableData[i].author.name;
						if(this.authorArr.indexOf(str)<0){
							this.authorArr.push(str);
						}
				}
			},
			requestFile(param) {
				this.uploadBtn=true;
				var fileObj = param.file
				let config = {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				};
				var form = new FormData() // FormData 对象
				var token = JSON.parse(window.localStorage.getItem("data")).data
				form.append('file', fileObj) // 文件对象
				form.append('token', token) // 文件对象
				axios.post(SEVSRS + 'rescue/case/upload_file', form, config)
					.then(res => {
						if (res.data.code == 0) {
							this.fileUrl.push(res.data.obj);
							this.uploadBtn=false;
						}
					})
					.catch(err => {
						console.log(err)
					})
			},
			//上传
			handleRemove(file, fileList) {
        console.log(this.fileInd)
        console.log(this.fileUrl)
        this.fileUrl.splice(this.fileInd, 1);
        console.log(this.fileUrl)
			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
        for (let i = 0; i < fileList.length; i++) {
          if (JSON.stringify(fileList[i].uid) === JSON.stringify(file.uid)) {
            this.fileInd = i
          }
       }
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			beforeAvatarUpload(file) {
				const isLt8M = file.size / 1024 / 1024 < 8;
				if (!isLt8M) {
					this.$message.error('上传头像图片大小不能超过 8MB!');
				}
				return isLt8M;
			},
			uploadFile(){
        console.log(this.fileUrl)
        // return
				if(this.fileUrl.length<1){
					this.$message.error('请添加附件!');
				}else{
          console.log(this.form.status)
          // return
							var objArr=[];

							for(var i=0;i<this.fileUrl.length;i++){
								var obj={
									description:this.desc,
									objType:4,
									type:this.caseState,
									objId:this.caseid,
                  status:this.form.status,
									url:this.fileUrl[i]
								}
								objArr.push(obj);
							}
							var data={
								tUploadCnts:JSON.stringify(objArr),
                caseId:this.$route.query.caseid,
								token:JSON.parse(window.localStorage.getItem("data")).data,
							}
							uploadFile(data)
							.then( res =>{
								this.$message({
									message: '附件上传成功',
									type: 'success'
								});
								this.desc='';
								this.fileList=[];
								this.fileUrl=[];
								this.updialog=false;
								this.getData();
							}).catch( err =>{
								console.log(err)
							})
				}

			}
    },
		mounted() {
			this.caseid=this.$route.query.caseid;
			this.caseState=this.$route.query.caseState
			console.log(this.caseid)
			this.getData()
		}
  }
</script>

<style scoped>
.tit{
	font-size: 22px;
	color: #333;
	width: 100%;
	text-align: center;
	padding-top: 88px;
}
.el-form-item{
	width:auto;
	display: inline-block;
}
/* .look{
	border: 0;
	color: #00abfa;
} */
a{
	text-decoration: none;
	color: #00abfa;
	cursor: pointer;
}
.has-gutter th {
		background-color: #f5f7fb;
	}
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  .wrap{background: white;min-height: 100vh;}
</style>



// WEBPACK FOOTER //
// src/views/cmd_center/anjianList.vue